module.exports = "../../static/fonts/Gotham-Medium.0b28710.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Gotham-Medium.ttf
// module id = 5/xA
// module chunks = 47